import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FiX } from 'react-icons/fi';
import authService from '../services/authService';

export default function Setup2FAModal({ isOpen, onClose }) {
  const [qrCodeImage, setQrCodeImage] = useState(null);
  const [codigo, setCodigo] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);

  if (!isOpen) return null;

  const handleGerarQrCode = async () => {
    try {
      setLoading(true);
      const data = await authService.setup2FA();
      setQrCodeImage(data.qrCodeImage);
      setStep(2);
    } catch (error) {
      toast.error('Erro ao gerar código QR');
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmarSetup = async (e) => {
    e.preventDefault();
    if (codigo.length !== 6) return;
    try {
      setLoading(true);
      await authService.confirmSetup2FA(codigo);
      toast.success('Autenticação de 2 Fatores Ativada com Sucesso!');
      onClose();
    } catch (error) {
      toast.error(error.mensagem || 'Código 2FA Inválido. Tente Novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden relative">
        <div className="flex justify-between items-center p-6 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-800">Ativar Segurança 2FA</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition">
            <FiX size={24} />
          </button>
        </div>

        <div className="p-6">
          {step === 1 ? (
            <div className="text-center space-y-4">
              <p className="text-gray-600 text-sm">
                Proteja sua conta utilizando um aplicativo autenticador como Google Authenticator ou Authy. 
                Sua conta ficará segura exigindo um código de 6 dígitos sempre que você entrar.
              </p>
              <button
                onClick={handleGerarQrCode}
                disabled={loading}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-xl shadow-lg transition disabled:opacity-50"
              >
                {loading ? 'Preparando Setup...' : 'Gerar QR Code de Ativação'}
              </button>
            </div>
          ) : (
            <form onSubmit={handleConfirmarSetup} className="text-center space-y-5 animate-in slide-in-from-right-4 duration-300">
              <p className="text-gray-700 text-sm">Escaneie o QR Code no seu aplicativo Autenticador:</p>

              <div className="bg-gray-100 p-4 rounded-2xl flex justify-center items-center shadow-inner mx-auto w-48 h-48">
                {qrCodeImage ? (
                  <img src={qrCodeImage} alt="QR Code 2FA" className="w-full h-full object-contain mix-blend-multiply" />
                ) : (
                  <div className="animate-pulse bg-gray-300 w-full h-full rounded-xl"></div>
                )}
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">Digite o código gerado pelo aplicativo</label>
                <input
                  type="text"
                  maxLength="6"
                  required
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value.replace(/\D/g, ''))}
                  placeholder="000000"
                  className="w-3/4 mx-auto px-4 py-3 text-center text-3xl font-black tracking-widest text-blue-700 border-2 border-gray-300 rounded-xl focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none"
                />
              </div>

              <div className="pt-2">
                <button
                  type="submit"
                  disabled={loading || codigo.length !== 6}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-xl shadow transition disabled:opacity-50"
                >
                  {loading ? 'Verificando...' : 'Confirmar e Ativar 2FA'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
